import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Box,
  Button,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditItemView from "../common/components/EditItemView";
import { useTranslation } from "../common/components/LocalizationProvider";

const SupplierPage = () => {
  const t = useTranslation();

  // ✅ IMPORTANT FIX: let EditItemView control the data
  const [item, setItem] = useState();

  const [activityInput, setActivityInput] = useState("");

  // ✅ validation
  const validate = () => item && item.nom && item.phone;

  // ✅ add activity
  const addActivity = () => {
    const value = activityInput.trim();
    if (!value) return;

    setItem((prev) => {
      const activities = prev?.activites || [];
      if (activities.includes(value)) return prev;

      return {
        ...prev,
        activites: [...activities, value],
      };
    });

    setActivityInput("");
  };

  // ✅ remove activity
  const removeActivity = (value) => {
    setItem((prev) => ({
      ...prev,
      activites: prev.activites.filter((a) => a !== value),
    }));
  };

  return (
    <EditItemView
      endpoint="suppliers"
      item={item}
      setItem={setItem}
      validate={validate}
    >
      {item && (
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="subtitle1">
              {t("sharedRequired") || "Informations Fournisseur"}
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* NOM */}
            <TextField
              label="Nom du fournisseur"
              value={item.nom || ""}
              onChange={(e) =>
                setItem({ ...item, nom: e.target.value })
              }
              required
              fullWidth
            />

            {/* PHONE */}
            <TextField
              label="Téléphone"
              value={item.phone || ""}
              onChange={(e) =>
                setItem({ ...item, phone: e.target.value })
              }
              required
              fullWidth
            />

            {/* EMAIL */}
            <TextField
              label="Email"
              value={item.email || ""}
              onChange={(e) =>
                setItem({ ...item, email: e.target.value })
              }
              fullWidth
            />

            {/* PAYS */}
            <TextField
              label="Pays"
              value={item.pays || ""}
              onChange={(e) =>
                setItem({ ...item, pays: e.target.value })
              }
              fullWidth
            />

            {/* WEBSITE */}
            <TextField
              label="WebSite"
              value={item.website || ""}
              onChange={(e) =>
                setItem({ ...item, website: e.target.value })
              }
              fullWidth
            />

            {/* ADDRESS */}
            <TextField
              label="Adresse"
              value={item.address || ""}
              onChange={(e) =>
                setItem({ ...item, address: e.target.value })
              }
              fullWidth
              multiline
              rows={2}
            />

            {/* ACTIVITIES INPUT */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <TextField
                label="Ajouter activité"
                value={activityInput}
                onChange={(e) =>
                  setActivityInput(e.target.value)
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addActivity();
                  }
                }}
                fullWidth
              />

              <Button
                variant="contained"
                onClick={addActivity}
                sx={{ minWidth: 120 }}
              >
                Ajouter
              </Button>
            </Box>

            {/* ACTIVITIES CHIPS */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {item.activites?.map((a, i) => (
                <Chip
                  key={i}
                  label={a}
                  onDelete={() => removeActivity(a)}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>

            {/* NOTES */}
            <TextField
              label="Notes"
              value={item.notes || ""}
              onChange={(e) =>
                setItem({ ...item, notes: e.target.value })
              }
              fullWidth
              multiline
              rows={4}
            />
          </AccordionDetails>
        </Accordion>
      )}
    </EditItemView>
  );
};

export default SupplierPage;